import { render, staticRenderFns } from "./masterWriterApp.vue?vue&type=template&id=3c360a79&"
import script from "./masterWriterApp.vue?vue&type=script&lang=js&"
export * from "./masterWriterApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports